exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Imports
var getUrl = require("../../../css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL___0___ = getUrl(require("../resources/calendar_drophint_bw.svg"));
var ___CSS_LOADER_URL___1___ = getUrl(require("../resources/calendar_drophint.svg"));
// Module
exports.push([module.id, "html[dir] ._3rIWr9C4HU3EOIG2hZpYJA{background-image:url(" + ___CSS_LOADER_URL___0___ + ")}html[dir] ._3ir06E2SO5Wb4Ws7WrX8gs{background-image:url(" + ___CSS_LOADER_URL___1___ + ")}", ""]);
// Exports
exports.locals = {
	"eventDropHintIconBase": "_3rIWr9C4HU3EOIG2hZpYJA",
	"eventDropHintIconActive": "_3ir06E2SO5Wb4Ws7WrX8gs"
};